/* global axios */
import ApiClient from './ApiClient';

class CampaignMediaAPI extends ApiClient {
  constructor() {
    super('seggna/campaign_media', { accountScoped: true });
  }

  upload(file) {
    const data = new FormData();
    data.append('file', file);
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  rename(id, name) {
    return axios.patch(`${this.url}/${id}`, { name });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  process(id, kind) {
    return axios.post(`${this.url}/${id}/${kind}`);
  }

  operations() {
    return axios.get(`${this.baseUrl()}/seggna/campaign_media_operations`);
  }
}

export default new CampaignMediaAPI();
